import { EstadoVazio } from '../../componentes/ui';
import type { AbaDeConfiguracao } from './BarraDeAbas';

/**
 * As configurações do Créditos ICMS Pontual, na Central de Configurações.
 *
 * A negociação do Pontual não tem parâmetro de sistema: deságio, regra de
 * pagamento e honorários são combinados em cada uma. A aba diz isso em vez de
 * fingir uma configuração; quando houver o que parametrizar, entra aqui.
 */
export function abasDoPontual(): AbaDeConfiguracao[] {
  return [
    {
      id: 'parametros',
      rotulo: 'Parâmetros',
      conteudo: (
        <EstadoVazio
          titulo="O Pontual ainda não tem parâmetros para configurar"
          descricao="Deságio, forma de pagamento e honorários são combinados em cada negociação. Os modelos de contrato ficam no cadastro do fornecedor, na aba Serviços."
        />
      ),
    },
  ];
}
